import { Route, useRouteMatch } from 'react-router-dom';

import AuthContainer from '../../context/AuthContainer';
import NavigationBar from '../navigation/NavigationBar';
import { ActivePage } from '../navigation/types';
import { Container, Content } from './index.styles';
import TemplateContainer from './TemplateContext';
import TemplateManager from './TemplateManager';
import TemplateManagerCreateEdit from './TemplateManagerCreateEdit';
import { getUrlParams } from '../../utils/url';

const TemplateManagerRoutes = () => {
    const { path } = useRouteMatch();

    const { hide_navigation: hideNavigation } = getUrlParams();

    return (
        <AuthContainer.Provider>
            <TemplateContainer.Provider>
                {hideNavigation !== 'true' && <NavigationBar activePage={ActivePage.TEMPLATES} />}

                <Container>
                    <Content>
                        <Route exact path={`${path}`} component={TemplateManager} />
                        <Route exact path={`${path}/create`} component={TemplateManagerCreateEdit} />
                        <Route exact path={`${path}/edit/:templateId`} component={TemplateManagerCreateEdit} />
                    </Content>
                </Container>
            </TemplateContainer.Provider>
        </AuthContainer.Provider>
    );
};

export default TemplateManagerRoutes;
